import * as echarts from 'echarts';

export { echarts };
